import React, { memo } from 'react';

import { cssMap } from '@atlaskit/css';
import ShapesIcon from '@atlaskit/icon/core/shapes';
import { token } from '@atlaskit/tokens';
import {
	PreviewPanel,
	PreviewPanelBody,
	PreviewPanelHeader,
	PreviewPanelTitle,
} from '@atlassian/preview-panel';
import { usePreviewPanelsActions } from '@atlassian/preview-panels-api';

type Props = {
	name: string;
	url: string;
};

const styles = cssMap({
	body: {
		display: 'flex',
		flexGrow: 1,
		overflowY: 'auto',
		paddingInlineStart: token('space.300'),
		paddingInlineEnd: token('space.300'),
		paddingBlockStart: token('space.200'),
		paddingBlockEnd: token('space.200'),
	},
});

export const DummyPreviewPanel = memo(({ name, url }: Props) => {
	const { close } = usePreviewPanelsActions();

	return (
		<PreviewPanel>
			<PreviewPanelHeader onClose={close} url={url}>
				<PreviewPanelTitle title={name} icon={<ShapesIcon label="" />} />
			</PreviewPanelHeader>
			<PreviewPanelBody styles={styles.body}>
				This is a dummy preview panel. It can be used to test the layout and functionality of the
				preview panel without needing a real content source.
			</PreviewPanelBody>
		</PreviewPanel>
	);
});
